import { RefObject, useEffect } from "react";

function useOutsideClick(
  refs: RefObject<HTMLDivElement | HTMLButtonElement>[],
  onClick: () => void
) {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const target = event?.target as Node;
      const countOfOutOfScopes = refs.reduce((acc, ref) => {
        if (ref.current && !ref.current.contains(target)) {
          return acc + 1;
        }
        return acc;
      }, 0);
      if (countOfOutOfScopes === refs.length) {
        onClick();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [refs, onClick]);
}

export default useOutsideClick;
